export default "__VITE_ASSET__Br3g5z0q__"